import React from 'react';

import './Lisan.css';

const Lisan = () => {
  return (
    <>
      <div id='penerjemahan-lisan'>
        <div className='container-9'>
          <div className='div-lisan'>
            <ul>
              <li>
                <h1>Penerjemahan Lisan</h1>
                <p>
                  Jasa Penerjemahan Lisan atau Interpreter adalah sebuah jasa
                  alih bahasa secara verbal atau lisan, dimana penerjemah akan
                  menerjemahkan percakapan secara langsung. Kami menyediakan
                  layanan penerjemahan lisan dalam bahasa Inggris, bahasa Arab,
                  bahasa Korea, bahasa Jerman, dll.
                </p>
                <p>
                  Dalam prakteknya di lapangan, secara umum ada 2 jenis jasa
                  interpreting, yaitu:
                </p>
                <p>1. Simultan</p>
                <p>
                  Dalam kategori ini, Interpreter menerjemahkan ke dalam bahasa
                  target secepat mungkin, sementara pembicara bahasa sumber
                  terus berbicara.
                </p>
                <p>
                  Adapun standar harga dari layanan ini untuk 8 jam kerja adalah
                  Rp. 8,000.000,-
                </p>
                <p>2. Konsekutif</p>
                <p>
                  Dalam kategori ini, interpreter berbicara setelah pembicara
                  bahasa sumber selesai berbicara.
                </p>
                <p>
                  Adapun standar harga dari layanan ini untuk 8 jam kerja adalah
                  Rp. 5,000.000,-
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default Lisan;
